module.exports = __webpack_public_path__ + "img/30.1ba9ebf7.png";